export default __webpack_public_path__ + "static/HairFree-Hero-Tablet-v2-5eb2094915cf18124ad80fe5da15211d.webp";